let mainMenu , mainMenuLink ,loc , segments , lastSegment , topLevelMenu;
function onDocumentReady(){
    mainMenu = $('#main-nav');
    mainMenuLink = mainMenu.find('.menu-item-link');
    topLevelMenu = mainMenu.find('.menu-item-top-level');
    loc = window.location.pathname;
    segments = loc.split("/");
    lastSegment = segments[segments.length-2];
    mainMenu.addClass('show-menu');
    topLevelMenu.removeClass('menu-item-active');
    if(mainMenuLink.length){
        var menuUrl , urlSplit , slug;
        mainMenuLink.each(function(){
            menuUrl = $(this).attr('href');
            urlSplit = menuUrl.split("/");
            slug = urlSplit[urlSplit.length-2];
            if(slug === lastSegment){
                $(this).closest('.menu-item-top-level').addClass('menu-item-active');
            }
        });
    }
    topLevelMenu.hover(function(){
        topLevelMenu.removeClass('menu-item-active');
    });

}
document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/menu-active-controller.js